import {
  CustomerFolder as _CustomerFolder,
  ProjectFolder as _ProjectFolder,
  StructuralFolder as _StructuralFolder,
  GroupedFolder as _GroupedFolder,
} from "~/gql/types2";
import {
  CustomerFolder,
  GroupedFolder,
  ProjectFolder,
  StructuralFolder,
} from "./types";

export function organizeQueryResults(
  folders: _StructuralFolder[]
): StructuralFolder[] {
  return folders.map((f) => ({
    ...f,
    clientFolders: organizeClientFolders(f.clientFolders),
    __typename: "StructuralFolder",
  }));
}

function organizeClientFolders(folders: _CustomerFolder[]): CustomerFolder[] {
  return folders.map((f) => {
    const newFolder: CustomerFolder = {
      ...f,
      projectFolders: [...mapProjectWithTypename(f.projectFolders)],
      groupedFolders: [...mapGroupedWithTypename(f.groupedFolders)],
      __typename: "CustomerFolder",
    };

    return newFolder;
  });
}

function mapProjectWithTypename(folders: _ProjectFolder[]): ProjectFolder[] {
  return folders.map((f) => ({
    ...f,
    __typename: "ProjectFolder",
  }));
}

function mapGroupedWithTypename(folders: _GroupedFolder[]): GroupedFolder[] {
  return folders.map((f) => ({
    ...f,
    __typename: "GroupedFolder",
  }));
}
